import { render, staticRenderFns } from "./FiberSlider.vue?vue&type=template&id=f8cd3aba"
import script from "./FiberSlider.vue?vue&type=script&lang=js"
export * from "./FiberSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports